import { useCallback, useState } from 'react';

const NONE = { discount: false, advance: false, submitted: false };
const ALL = { discount: true, advance: true, submitted: true };

/**
 * Które pola kwot (rabat, zaliczka) POKAZUJĄ wynik walidacji — wspólne dla Nowej rezerwacji,
 * edycji rezerwacji i oferty (U.26).
 *
 * Pole zaczyna pokazywać limit po jego opuszczeniu albo po zmianie jednostki rabatu (`show`),
 * a przestaje, gdy ktoś znowu w nim pisze (`hide`), żeby nie krzyczeć w połowie wpisywania.
 * Zapis zatrzymany na kwotach pokazuje oba naraz i ustawia `submitted` (`showAll`); formularz
 * wczytany od nowa zaczyna z czystym stanem (`hideAll`).
 *
 * Sam komunikat celowo NIE jest tu trzymany: widok wylicza go przy każdym renderze z bieżącej
 * wartości i bieżącego limitu (`discountError`/`advanceError` + `amountErrorMessage`
 * z `utils/amountField.js`). Zapisany tekst zostawał nieaktualny — „Maksymalnie 900 zł" przy
 * zaliczce po usunięciu rabatu albo po zmianie sprzętu — a czyszczenie go przy każdej zmianie
 * ceny gasiło też błędy, które od ceny nie zależą (rabat 150%).
 */
export default function useAmountChecks() {
  const [shown, setShown] = useState(NONE);
  const show = useCallback(
    (field) => setShown((prev) => (prev[field] ? prev : { ...prev, [field]: true })),
    [],
  );
  const hide = useCallback(
    (field) => setShown((prev) => (prev[field] ? { ...prev, [field]: false } : prev)),
    [],
  );
  const showAll = useCallback(() => setShown(ALL), []);
  const hideAll = useCallback(() => setShown(NONE), []);
  return { shown, show, hide, showAll, hideAll };
}
